// import { io } from 'socket.io-client';
import API from './api';

// export default class WS {
//     private socket: WebSocket | null = null;
//     static instance;

//     constructor() {
//         WS.instance = this;
//     }

//     init() {
//         this.socket = new WebSocket(API.uri);

//         this.socket.addEventListener('open', () => {

//         });

//         this.socket.addEventListener('close', () => {

//         });

//         this.socket.addEventListener('error', () => {

//         });

//         this.socket = io(API.uri, { auth: { token: API.token } });
//         return new Promise((resolve) => {
//             this.socket.on('connect', () => {
//                 resolve();
//             });
//             this.socket.on('disconnect', (reason) => {});
//             this.socket.on('reconnect', () => {});
//             this.socket.on('reconnecting', () => {});
//         });
//     }

//     static listen(event, callback) {
//         if (!WS.instance.socket) return () => {};
//         WS.instance.socket.on(event, callback);

//         return () => {
//             WS.instance.socket.off(event, callback);
//         };
//     }

//     static unlisten(event, callback) {
//         if (!WS.instance.socket) return;
//         WS.instance.socket.off(event, callback);
//     }

//     static emit(event, data) {
//         if (!WS.instance.socket) return;
//         WS.instance.socket.emit(event, data);
//     }

//     static initialized() {
//         return WS.instance.socket;
//     }

//     static id() {
//         return WS.instance?.socket?.id;
//     }

//     static disconnectListener(callback) {
//         WS.listen('disconnect', callback);
//         return () => {
//             WS.unlisten('disconnect', callback);
//         };
//     }

//     static reportListener(props) {
//         const { id, onJoin, onClose, onDone } = props;
//         WS.emit('report', { id: id });
//         if (onJoin) WS.listen(`report_join_${id}`, props.onJoin);
//         if (onClose) WS.listen(`report_close_${id}`, props.onClose);
//         if (onDone) WS.listen(`report_done_${id}`, props.onDone);

//         return () => {
//             WS.emit('report_leave', { id: props.id });
//             if (onJoin) WS.unlisten(`report_join_${props.id}`, props.onJoin);
//             if (onClose) WS.unlisten(`report_close_${props.id}`, props.onClose);
//             if (onDone) WS.unlisten(`report_done_${props.id}`, props.onDone);
//         };
//     }

//     static advancedSettingsListener(props) {
//         const {
//             groupId,
//             locationId,
//             machineId,
//             onJoin,
//             onClose,
//             onWrite,
//             onRead,
//             onMachineReset,
//         } = props;
//         WS.emit('advanced_settings', { groupId, locationId, machineId });

//         if (onJoin) WS.listen('advanced_settings_join', onJoin);
//         if (onClose) WS.listen('advanced_settings_close', onClose);
//         if (onWrite) WS.listen('advanced_settings_write', onWrite);
//         if (onRead) WS.listen('advanced_settings_read', onRead);
//         if (onMachineReset)
//             WS.listen('advanced_settings_reset', onMachineReset);

//         return () => {
//             WS.emit('advanced_settings_leave', {
//                 groupId,
//                 locationId,
//                 machineId,
//             });
//             if (onJoin) WS.unlisten('advanced_settings_join', onJoin);
//             if (onClose) WS.unlisten('advanced_settings_close', onClose);
//             if (onWrite) WS.unlisten('advanced_settings_write', onWrite);
//             if (onRead) WS.unlisten('advanced_settings_read', onRead);
//             if (onMachineReset)
//                 WS.unlisten('advanced_settings_reset', onMachineReset);
//         };
//     }

//     static devListener(props) {
//         const { onJoin, onLog, onAppError, onAppErrorRemoved, onClose } = props;
//         WS.emit('dev');

//         if (onJoin) WS.listen('dev_join', onJoin);
//         if (onClose) WS.listen('dev_close', onClose);
//         if (onLog) WS.listen('dev_log', onLog);
//         if (onAppError) WS.listen('dev_apperror', onAppError);
//         if (onAppErrorRemoved)
//             WS.listen('dev_apperror_removed', onAppErrorRemoved);

//         return () => {
//             WS.emit('dev_leave');
//             if (onJoin) WS.unlisten('dev_join', onJoin);
//             if (onClose) WS.unlisten('dev_close', onClose);
//             if (onLog) WS.unlisten('dev_log', onLog);
//             if (onAppError) WS.unlisten('dev_apperror', onAppError);
//             if (onAppErrorRemoved)
//                 WS.unlisten('dev_apperror_removed', onAppErrorRemoved);
//         };
//     }
// }

type WSMessage = {
    event: string;
    payload?: unknown;
};

type WSEventHandler<T = unknown> = (payload: T) => void;

type WSOptions = {
    getToken: () => string | null | undefined;
    reconnectDelayMs?: number;
    maxReconnectDelayMs?: number;
};

export class WS {
    private ws: WebSocket | null = null;
    private started = false;
    private reconnectTimer: number | null = null;
    private reconnectAttempt = 0;
    private manuallyClosed = false;
    private authenticated = false;
    private readonly handlers = new Map<string, Set<WSEventHandler>>();
    private readonly outbox: WSMessage[] = [];
    private readonly maxQueueSize = 200;

    constructor(
        private readonly url: string,
        private readonly options: WSOptions,
    ) {}

    start() {
        if (this.started) return;
        this.started = true;
        this.manuallyClosed = false;
        this.connect();
    }

    stop() {
        this.started = false;
        this.manuallyClosed = true;
        this.authenticated = false;

        if (this.reconnectTimer !== null) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }

        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
    }

    send(event: string, payload?: unknown) {
        const msg: WSMessage = { event, payload };

        if (this.canSendNow()) {
            this.sendNow(msg);
            return;
        }

        this.enqueue(msg);
    }

    on<T = unknown>(event: string, handler: WSEventHandler<T>) {
        const set = this.handlers.get(event) ?? new Set();
        set.add(handler as WSEventHandler);
        this.handlers.set(event, set);

        return () => this.off(event, handler);
    }

    off<T = unknown>(event: string, handler: WSEventHandler<T>) {
        const set = this.handlers.get(event);
        if (!set) return;
        set.delete(handler as WSEventHandler);
        if (set.size === 0) this.handlers.delete(event);
    }

    isConnected() {
        return this.ws?.readyState === WebSocket.OPEN;
    }

    isAuthenticated() {
        return this.authenticated;
    }

    isStarted() {
        return this.started;
    }

    private canSendNow() {
        return (
            this.ws !== null &&
            this.ws.readyState === WebSocket.OPEN &&
            this.authenticated
        );
    }

    private sendNow(msg: WSMessage) {
        this.ws?.send(JSON.stringify(msg));
    }

    private enqueue(msg: WSMessage) {
        if (this.outbox.length >= this.maxQueueSize) {
            this.outbox.shift();
        }
        this.outbox.push(msg);
    }

    private flushQueue() {
        if (!this.canSendNow()) return;

        while (this.outbox.length > 0 && this.canSendNow()) {
            const msg = this.outbox.shift();
            if (!msg) break;
            this.sendNow(msg);
        }
    }

    private connect() {
        if (!this.started) return;
        if (
            this.ws &&
            (this.ws.readyState === WebSocket.OPEN ||
                this.ws.readyState === WebSocket.CONNECTING ||
                this.ws.readyState === WebSocket.CLOSING)
        )
            return;

        this.ws = new WebSocket(this.url);

        this.ws.addEventListener('open', () => {
            this.reconnectAttempt = 0;
            this.emitLocal('socket_open', undefined);

            const token = this.options.getToken();
            if (!token) {
                this.emitLocal('auth_error', {
                    message: 'Missing auth token',
                });
                this.ws?.close();
                return;
            }

            this.ws?.send(
                JSON.stringify({
                    event: 'auth',
                    payload: { token },
                }),
            );
        });

        this.ws.addEventListener('message', (ev) => {
            let msg: WSMessage;

            try {
                msg = JSON.parse(ev.data);
            } catch {
                return;
            }

            if (msg.event === 'auth_error') {
                this.authenticated = false;
                this.emitLocal('auth_error', msg.payload);
                this.ws?.close();
                return;
            }

            if (msg.event === 'auth_ok') {
                this.authenticated = true;
                this.reconnectAttempt = 0;
                this.flushQueue();
                return;
            }

            this.emitLocal(msg.event, msg.payload);
        });

        this.ws.addEventListener('close', () => {
            this.authenticated = false;
            this.ws = null;

            if (!this.started || this.manuallyClosed) return;
            this.scheduleReconnect();
        });

        this.ws.addEventListener('error', () => {
            this.emitLocal('socket_error', undefined);
        });
    }

    private scheduleReconnect() {
        if (this.reconnectTimer !== null) return;

        const baseDelay = this.options.reconnectDelayMs ?? 1000;
        const maxDelay = this.options.maxReconnectDelayMs ?? 10000;
        const delay = Math.min(
            baseDelay * Math.max(1, 2 ** this.reconnectAttempt),
            maxDelay,
        );

        this.reconnectAttempt += 1;

        this.reconnectTimer = window.setTimeout(() => {
            this.reconnectTimer = null;
            this.connect();
        }, delay);
    }

    private emitLocal(event: string, payload: unknown) {
        const set = this.handlers.get(event);
        if (!set) return;

        for (const handler of set) {
            handler(payload);
        }
    }
}

export const ws = new WS(API.uri + '/ws', {
    getToken: () => API.token,
});
